/** V2 UI strings — merged into Translation.js (same mechanism as V1). */
const v2Translations = {
  v2_last_month: { fr: "le mois dernier", en: "last month" },
  v2_vs_last_month: { fr: "vs le mois dernier", en: "vs last month" },
  v2_vs_last_year: { fr: "vs l'année dernière", en: "vs last year" },
  v2_loading: { fr: "Chargement...", en: "Loading..." },
  v2_loading_data: { fr: "Chargement des données...", en: "Loading data..." },
  v2_error_load_data: {
    fr: "Erreur lors du chargement des données. Veuillez réessayer plus tard.",
    en: "Error loading data. Please try again later.",
  },
  v2_error_load_data_short: {
    fr: "Erreur lors du chargement des données. Veuillez réessayer.",
    en: "Error loading data. Please try again.",
  },
  v2_error_load_data_plain: {
    fr: "Erreur lors du chargement des données",
    en: "Error loading data",
  },
  v2_no_data: { fr: "Aucune donnée disponible", en: "No data available" },
  v2_no_data_period: {
    fr: "Pas de données disponibles pour cette période.",
    en: "No data available for this period.",
  },
  v2_data_not_yet_available: {
    fr: "Les données ne sont pas encore disponibles pour cette période.",
    en: "Data is not yet available for this period.",
  },
  v2_chart_no_data: {
    fr: "Pas de données disponibles pour le graphique.",
    en: "No data available for the chart.",
  },
  v2_pending_data_line1: { fr: "Les données", en: "Data is" },
  v2_pending_data_line2: { fr: "sont en cours", en: "being" },
  v2_pending_data_line3: { fr: "de récupération", en: "retrieved" },

  v2_sidebar_water_savings: { fr: "Économies eau", en: "Water savings" },
  v2_sidebar_cleaning_savings: { fr: "Économies ménage", en: "Cleaning savings" },
  v2_header_select_hotel: { fr: "Sélectionnez un hôtel", en: "Select a hotel" },
  v2_header_hotel_fallback: { fr: "Hôtel {id}", en: "Hotel {id}" },
  v2_header_my_hotels: { fr: "Mes hôtels", en: "My hotels" },
  v2_header_book_appointment: { fr: "Prendre rendez-vous", en: "Book an appointment" },
  v2_header_hotel_icon_alt: { fr: "Icône hôtel", en: "Hotel icon" },
  v2_header_calendar_icon_alt: { fr: "Icône calendrier", en: "Calendar icon" },

  v2_my_hotels_title: { fr: "Vos hôtels", en: "Your hotels" },
  v2_my_hotels_sidebar_all: { fr: "Tous mes hôtels", en: "All my hotels" },
  v2_my_hotels_contact: { fr: "Nous contacter", en: "Contact us" },
  v2_my_hotels_error: {
    fr: "Erreur lors du chargement des hôtels. Veuillez réessayer plus tard.",
    en: "Error loading hotels. Please try again later.",
  },
  v2_my_hotels_empty: { fr: "Aucun hôtel disponible pour le moment.", en: "No hotels available at the moment." },
  v2_my_hotels_savings_summary: { fr: "Synthèse des économies", en: "Savings summary" },
  v2_my_hotels_installation_date: { fr: "Installé depuis le {date}", en: "Installed since {date}" },

  v2_dashboard_financial_savings: { fr: "Économies financières", en: "Financial savings" },
  v2_dashboard_water_savings: { fr: "Eau économisée", en: "Water saved" },
  v2_dashboard_greenmiles_users: { fr: "Utilisateurs GreenMiles", en: "GreenMiles users" },
  v2_dashboard_chart_monthly_title: { fr: "Économies financières mensuelles", en: "Monthly financial savings" },
  v2_dashboard_chart_monthly_subtitle: {
    fr: "Aperçu de l'évolution de vos économies par mois",
    en: "Overview of your monthly savings trend",
  },
  v2_dashboard_chart_legend: { fr: "Économies financières", en: "Financial savings" },
  v2_dashboard_declined_rooms: { fr: "Chambres ayant déclinés des services", en: "Rooms that declined services" },
  v2_dashboard_declined_recent: { fr: "Services déclinés récents", en: "Recent declined services" },
  v2_dashboard_no_declined: { fr: "Aucun service décliné récemment", en: "No services declined recently" },
  v2_dashboard_all_rooms: { fr: "Toutes les chambres", en: "All rooms" },
  v2_dashboard_active_stays: { fr: "Séjours actifs aujourd'hui", en: "Active stays today" },
  v2_dashboard_active_stays_sub: { fr: "Utilisation de l'application par vos clients", en: "App usage by your guests" },
  v2_dashboard_no_recent_action: { fr: "Aucune action récente", en: "No recent actions" },
  v2_dashboard_top_actions: { fr: "Top des actions réalisées sur le mois", en: "Top actions this month" },
  v2_dashboard_top_actions_sub: { fr: "Les actions les plus utilisées", en: "Most used actions" },
  v2_dashboard_recent_reviews: { fr: "Derniers avis", en: "Latest reviews" },
  v2_dashboard_recent_reviews_sub: { fr: "Ce que vos clients disent", en: "What your guests are saying" },
  v2_dashboard_no_recent_review: { fr: "Aucun avis récent", en: "No recent reviews" },

  v2_actions_water_title: { fr: "Économies eau", en: "Water savings" },
  v2_actions_water_card_water: { fr: "Eau économisée", en: "Water saved" },
  v2_actions_water_card_energy: { fr: "Énergie économisée", en: "Energy saved" },
  v2_actions_water_shower_title: { fr: "Consommation moyenne des douches", en: "Average shower consumption" },
  v2_actions_water_shower_subtitle: {
    fr: "Suivi de la consommation d'eau de vos clients par mois",
    en: "Monthly tracking of your guests' water consumption",
  },
  v2_actions_water_evolution_title: { fr: "Évolution de vos économies", en: "Your savings trend" },
  v2_actions_water_evolution_subtitle: { fr: "En eau et en énergie", en: "Water and energy" },
  v2_actions_water_legend_without: { fr: "Consommation sans Lunishower (m3)", en: "Consumption without LuniShower (m³)" },
  v2_actions_water_legend_with: { fr: "Consommation avec Lunishower (m3)", en: "Consumption with LuniShower (m³)" },
  v2_actions_water_legend_water_m3: { fr: "Économie d'eau (m3)", en: "Water savings (m³)" },
  v2_actions_water_legend_energy_kwh: { fr: "Économie d'énergie (kWh)", en: "Energy savings (kWh)" },
  v2_actions_water_tooltip_water: { fr: "Économie d'eau", en: "Water savings" },
  v2_actions_water_tooltip_energy: { fr: "Économie d'énergie", en: "Energy savings" },

  v2_actions_cleaning_title: { fr: "Gestion du ménage", en: "Housekeeping management" },
  v2_actions_cleaning_services_declined: { fr: "Nombre de services déclinés", en: "Number of declined services" },
  v2_actions_cleaning_financial_savings: { fr: "Économies financières", en: "Financial savings" },
  v2_actions_cleaning_table_service: { fr: "Service décliné", en: "Declined service" },
  v2_actions_cleaning_table_count: { fr: "Nombre de services déclinés", en: "Number of declined services" },
  v2_actions_cleaning_table_gain: { fr: "Gain par action", en: "Savings per action" },
  v2_actions_cleaning_table_savings: { fr: "Économies", en: "Savings" },
  v2_actions_cleaning_recipient: { fr: "Destinataire", en: "Recipient" },
  v2_actions_cleaning_language: { fr: "Langue", en: "Language" },
  v2_actions_cleaning_last_sent: { fr: "Dernier envoi", en: "Last sent" },
  v2_actions_cleaning_no_recipients: { fr: "Aucun destinataire configuré", en: "No recipients configured" },
  v2_actions_cleaning_section_declined: {
    fr: "Services déclinés et économies associées",
    en: "Declined services and related savings",
  },
  v2_actions_cleaning_section_total: { fr: "Total depuis le début", en: "Total since the beginning" },
  v2_actions_cleaning_section_recipients: {
    fr: "Destinataires de l'email services déclinés",
    en: "Declined services email recipients",
  },
  v2_actions_cleaning_section_recipients_sub: {
    fr: "Nous vous envoyons un e-mail récapitulatif des chambres concernées par le déclin d'un service. (ménage, draps, etc...)",
    en: "We send you a summary email of rooms that declined a service (housekeeping, linens, etc.).",
  },

  v2_greenmiles_title: { fr: "Mon application GreenMiles", en: "My GreenMiles app" },
  v2_greenmiles_users: { fr: "Utilisateurs GreenMiles", en: "GreenMiles users" },
  v2_greenmiles_usage: { fr: "Utilisation de GreenMiles", en: "GreenMiles usage" },
  v2_greenmiles_scan_rate: { fr: "Taux de scan", en: "Scan rate" },
  v2_greenmiles_stays_footer: { fr: "séjours GreenMiles", en: "GreenMiles stays" },
  v2_greenmiles_usage_footer: { fr: "de séjours avec au moins une action", en: "of stays with at least one action" },
  v2_greenmiles_scan_rate_footer: { fr: "de séjours ayant utilisé GreenMiles", en: "of stays that used GreenMiles" },
  v2_greenmiles_actions_title: { fr: "Vos actions", en: "Your actions" },
  v2_greenmiles_actions_subtitle: { fr: "Liste de vos actions et usage associé", en: "List of your actions and related usage" },
  v2_greenmiles_action_name: { fr: "Nom action", en: "Action name" },
  v2_greenmiles_action_count: { fr: "Nombre effectué", en: "Count completed" },
  v2_greenmiles_no_actions: { fr: "Aucune action configurée", en: "No actions configured" },
  v2_greenmiles_rewards_title: { fr: "Vos récompenses", en: "Your rewards" },
  v2_greenmiles_rewards_subtitle: { fr: "Liste de vos récompenses et usage associé", en: "List of your rewards and related usage" },
  v2_greenmiles_reward_name: { fr: "Nom récompense", en: "Reward name" },
  v2_greenmiles_reward_unlocked: { fr: "Nombre débloquées", en: "Unlocked count" },
  v2_greenmiles_reward_required: { fr: "GreenMiles nécessaires", en: "GreenMiles required" },
  v2_greenmiles_no_rewards: { fr: "Aucune récompense configurée", en: "No rewards configured" },

  v2_actions_list_title: { fr: "Ma liste d'actions", en: "My action list" },
  v2_actions_list_monetary: { fr: "Économies monétaires", en: "Monetary savings" },
  v2_actions_list_by_type: { fr: "Par type d'action", en: "By action type" },
  v2_actions_list_water: { fr: "Économies en eau", en: "Water savings" },
  v2_actions_list_gm_usage: { fr: "Utilisation de GreenMiles", en: "GreenMiles usage" },
  v2_actions_list_stays_action: { fr: "Séjours avec au moins une action", en: "Stays with at least one action" },
  v2_actions_list_usage_stats: { fr: "Statistiques d'utilisation", en: "Usage statistics" },
  v2_actions_list_usage_trends: { fr: "Tendances d'usage", en: "Usage trends" },
  v2_actions_list_resource_savings: {
    fr: "Économie de ressources naturelles et énergétiques",
    en: "Natural resource and energy savings",
  },
  v2_actions_list_pollution: { fr: "Diminution de la pollution", en: "Pollution reduction" },
  v2_actions_list_gm_distribution: { fr: "Distribution de GreenMiles", en: "GreenMiles distribution" },
  v2_actions_list_action_name: { fr: "Nom action", en: "Action name" },
  v2_actions_list_gm_per_action: { fr: "GM par action", en: "GM per action" },
  v2_actions_list_co2: { fr: "Economies en CO2", en: "CO₂ savings" },
  v2_actions_list_water_header: { fr: "Eau", en: "Water" },
  v2_actions_list_energy_header: { fr: "Energie", en: "Energy" },
  v2_actions_list_no_action_month: { fr: "Aucune action effectuée ce mois", en: "No actions completed this month" },
  v2_actions_list_usage_action: { fr: "Action", en: "Action" },
  v2_actions_list_usage_type: { fr: "Type", en: "Type" },
  v2_actions_list_usage_total: { fr: "Total économie", en: "Total savings" },
  v2_actions_list_usage_time: { fr: "Temps d'usage", en: "Usage time" },
  v2_actions_list_usage_opens: { fr: "Nb d'ouverture", en: "Open count" },
  v2_actions_list_usage_percent: { fr: "Utilisation %", en: "Usage %" },

  v2_actions_surveys_title: { fr: "Mes sondages", en: "My surveys" },
  v2_actions_surveys_reviews: { fr: "Mes Reviews", en: "My reviews" },
  v2_actions_surveys_reviews_sub: { fr: "Toutes mes actions reviews", en: "All my review actions" },
  v2_actions_surveys_no_review: { fr: "Aucun sondage review disponible", en: "No review survey available" },
  v2_actions_surveys_quizzes: { fr: "Mes Quiz", en: "My quizzes" },
  v2_actions_surveys_quizzes_sub: { fr: "Réponses choisies par les utilisateurs", en: "Answers chosen by users" },
  v2_actions_surveys_no_quiz: { fr: "Aucun quiz disponible", en: "No quiz available" },
  v2_actions_surveys_review_period: { fr: "Période moyenne de réponse Review", en: "Average review response period" },
  v2_actions_surveys_weighted_week: { fr: "Moyenne pondérée sur une semaine", en: "Weighted average over one week" },
  v2_actions_surveys_quiz_period: { fr: "Période moyenne de réponse Quiz", en: "Average quiz response period" },

  v2_actions_reviews_title: { fr: "Mes avis", en: "My reviews" },
  v2_actions_reviews_summary_title: { fr: "Résumé des avis sur les produits Luniwave", en: "Luniwave product reviews summary" },
  v2_actions_reviews_summary_sub: {
    fr: "Moyenne de notation sur Lunishower et GreenMiles",
    en: "Average rating on LuniShower and GreenMiles",
  },
  v2_actions_reviews_no_data: { fr: "Aucune donnée", en: "No data" },
  v2_actions_reviews_platforms_title: { fr: "Avis par plateforme", en: "Reviews by platform" },
  v2_actions_reviews_platforms_sub: { fr: "Vos clients ont commenté sur", en: "Your guests reviewed on" },
  v2_actions_reviews_products_title: { fr: "Avis sur les produits", en: "Product reviews" },
  v2_actions_reviews_products_sub: { fr: "Derniers avis de vos clients", en: "Latest guest reviews" },
  v2_actions_reviews_loading: { fr: "Chargement des avis...", en: "Loading reviews..." },
  v2_actions_reviews_error: { fr: "Erreur lors du chargement des avis", en: "Error loading reviews" },
  v2_actions_reviews_empty: { fr: "Aucun avis disponible", en: "No reviews available" },

  v2_rewards_list_title: { fr: "Ma liste de récompenses", en: "My rewards list" },
  v2_rewards_top_obtention: { fr: "Obtention des récompenses", en: "Rewards obtained" },
  v2_rewards_top_obtention_sub: { fr: "Voir l'usage et les réclamations", en: "View usage and claims" },
  v2_rewards_top_avg_claim: { fr: "Moyenne de réclamation", en: "Average claim rate" },
  v2_rewards_top_avg_claim_sub: { fr: "Récompenses réclamées sur les séjours GM", en: "Rewards claimed on GM stays" },
  v2_rewards_analysis_title: { fr: "Analyse par type de récompense", en: "Analysis by reward type" },
  v2_rewards_analysis_sub: { fr: "Voir l'usage par type", en: "View usage by type" },
  v2_rewards_analysis_name: { fr: "Nom de la récompense", en: "Reward name" },
  v2_rewards_analysis_type: { fr: "Type", en: "Type" },
  v2_rewards_analysis_obtained: { fr: "Obtenues", en: "Obtained" },
  v2_rewards_analysis_claimed: { fr: "Réclamées", en: "Claimed" },
  v2_rewards_analysis_learn_more: { fr: "En savoir +", en: "Learn more" },
  v2_rewards_benefits_title: { fr: "Bénéfices par récompense", en: "Benefits per reward" },
  v2_rewards_benefits_sub: { fr: "Suivez les gains générés par chaque récompense", en: "Track gains generated by each reward" },
  v2_rewards_benefits_claim_count: { fr: "Nb. Réclamaton", en: "Claim count" },
  v2_rewards_benefits_total_gain: { fr: "Gain totaux", en: "Total gains" },
  v2_rewards_modal_close: { fr: "Fermer", en: "Close" },
  v2_rewards_modal_no_description: { fr: "Aucune description disponible.", en: "No description available." },
  v2_rewards_modal_volume: { fr: "Volume:", en: "Volume:" },

  v2_rewards_donations_title: { fr: "Mes dons", en: "My donations" },
  v2_rewards_donations_error: {
    fr: "Erreur lors du chargement des statistiques. Veuillez réessayer plus tard.",
    en: "Error loading statistics. Please try again later.",
  },
  v2_rewards_donations_water: { fr: "Mes dons d'eau", en: "My water donations" },
  v2_rewards_donations_water_sub: { fr: "Quantité totale donnée en litres", en: "Total quantity donated in litres" },
  v2_rewards_donations_people: { fr: "Nombre de personnes aidées", en: "Number of people helped" },
  v2_rewards_donations_annual: { fr: "Total annuel", en: "Annual total" },
  v2_rewards_donations_action: { fr: "Utilisation de l'action de don", en: "Donation action usage" },
  v2_rewards_donations_monthly_avg: { fr: "Moyenne mensuelle en %", en: "Monthly average (%)" },
  v2_rewards_donations_by_stay: { fr: "Dons par durée de séjour", en: "Donations by stay duration" },
  v2_rewards_donations_annual_analysis: { fr: "Analyse annuelle", en: "Annual analysis" },
  v2_rewards_donations_distribution: { fr: "Répartition des dons selon leur quantité", en: "Donation distribution by quantity" },
  v2_rewards_donations_annual_dist: { fr: "Distribution annuelle", en: "Annual distribution" },
  v2_rewards_donations_chart_count: { fr: "Nombre de dons", en: "Number of donations" },

  v2_rewards_sales_title: { fr: "Ventes additionnelles", en: "Add-on sales" },
  v2_rewards_sales_annual: { fr: "Ventes additionnelles annuelles", en: "Annual add-on sales" },
  v2_rewards_sales_revenue_sub: { fr: "Revenu total généré cette année", en: "Total revenue generated this year" },
  v2_rewards_sales_top_products: { fr: "Top produits additionnels", en: "Top add-on products" },
  v2_rewards_sales_top_sub: { fr: "Classement des meilleures ventes de l'année", en: "Best sales ranking for the year" },
  v2_rewards_sales_by_type: { fr: "Ventes additionnelles par type de produit", en: "Add-on sales by product type" },
  v2_rewards_sales_by_type_sub: { fr: "Analyse des performances par catégorie", en: "Performance analysis by category" },
  v2_rewards_sales_unnamed: { fr: "Sans nom", en: "Unnamed" },

  v2_rewards_tips_title: { fr: "Pourboires", en: "Tips" },
  v2_rewards_tips_placeholder: { fr: "Page Pourboires - Contenu à venir", en: "Tips page — content coming soon" },
  v2_economies_title: { fr: "Économies", en: "Savings" },
  v2_economies_placeholder: { fr: "Page Économies - Contenu à venir", en: "Savings page — content coming soon" },

  v2_hotel_utility_title: { fr: "Vos coûts", en: "Your costs" },
  v2_hotel_utility_water: { fr: "Coût m³ d'eau", en: "Water cost per m³" },
  v2_hotel_utility_energy: { fr: "Coût kWh d'énergie", en: "Energy cost per kWh" },

  v2_graph_prev_year: { fr: "Année précédente", en: "Previous year" },
  v2_graph_next_year: { fr: "Année suivante", en: "Next year" },
  v2_graph_year_label: { fr: "Année {year}", en: "Year {year}" },

  v2_month_nav_aria: { fr: "Sélecteur de mois et année", en: "Month and year selector" },
  v2_month_prev: { fr: "Mois précédent", en: "Previous month" },
  v2_month_label: { fr: "Mois", en: "Month" },
  v2_year_label: { fr: "Année", en: "Year" },
  v2_month_next: { fr: "Mois suivant", en: "Next month" },

  v2_year_nav_aria: { fr: "Sélecteur d'année", en: "Year selector" },
  v2_year_prev: { fr: "Année précédente", en: "Previous year" },
  v2_year_next: { fr: "Année suivante", en: "Next year" },

  v2_hotel_selector_loading: { fr: "Chargement...", en: "Loading..." },
  v2_hotel_selector_empty: { fr: "Aucun hôtel disponible", en: "No hotel available" },
  v2_hotel_selector_placeholder: { fr: "Sélectionner un hôtel", en: "Select a hotel" },

  v2_sales_product_name: { fr: "Nom du produit", en: "Product name" },
  v2_sales_usage_count: { fr: "Nombre d'utilisation", en: "Usage count" },
  v2_sales_upsales_per_sale: { fr: "Upsales par vente", en: "Upsales per sale" },
  v2_sales_upsales_total: { fr: "Upsales totales", en: "Total upsales" },

  v2_water_explainer_title: { fr: "Comment sont calculées vos économies ?", en: "How are your savings calculated?" },
  v2_savings_word: { fr: "Économies", en: "Savings" },
  v2_water_explainer_water_saved: { fr: "eau économisée", en: "water saved" },
  v2_water_explainer_energy_saved: { fr: "énergie économisée", en: "energy saved" },
  v2_water_explainer_cost_water: { fr: "*Coût m³ d'eau", en: "*Water cost per m³" },
  v2_water_explainer_cost_energy: { fr: "*Coût kWh d'énergie", en: "*Energy cost per kWh" },
  v2_water_explainer_calc_water_prefix: { fr: "Calcul de l'", en: "Calculation of " },
  v2_water_explainer_calc_energy_prefix: { fr: "Calcul de l'", en: "Calculation of " },
  v2_water_explainer_water_description: {
    fr: "Correspond à la différence entre la consommation moyenne d'eau avant LuniShower et après LuniShower.",
    en: "Corresponds to the difference between average water consumption before LuniShower and after LuniShower.",
  },
  v2_water_explainer_water_witness_note: {
    fr: "La consommation avant LuniShower est estimée grâce aux chambres témoins, qui mesurent la consommation d'eau sans que le LuniShower ne soit actif.",
    en: "Consumption before LuniShower is estimated using witness rooms, which measure water consumption without LuniShower being active.",
  },
  v2_water_explainer_energy_description: {
    fr: "Correspond à l'énergie nécessaire pour faire chauffer le volume d'eau économisé.",
    en: "Corresponds to the energy needed to heat the volume of water saved.",
  },
  v2_water_explainer_energy_params_intro: {
    fr: "Ce calcul est basé sur les paramètres suivants :",
    en: "This calculation is based on the following settings:",
  },
  v2_water_explainer_cold_temp: { fr: "Température de l'eau froide", en: "Cold water temperature" },
  v2_water_explainer_hot_temp: { fr: "Température de l'eau chaude", en: "Hot water temperature" },
  v2_water_explainer_heating_type: { fr: "Type de chauffe (gaz, électricité)", en: "Heating type (gas, electricity)" },
  v2_water_explainer_energy_efficiency: { fr: "Efficacité énergétique", en: "Energy efficiency" },
  v2_cleaning_icon_towels: { fr: "Serviettes", en: "Towels" },
  v2_actions_water_pollution_title: { fr: "Réduction de la pollution", en: "Pollution reduction" },
  v2_actions_water_pollution_energy: { fr: "Énergie économisée", en: "Energy saved" },
  v2_actions_water_pollution_co2: { fr: "CO2 économisé", en: "CO₂ saved" },
  v2_actions_water_shower_analysis_title: {
    fr: "Analyse de la consommation d'eau des douches",
    en: "Shower water consumption analysis",
  },
  v2_actions_water_shower_analysis_sub: {
    fr: "Répartition annuelle des douches par catégorie de consommation",
    en: "Annual shower distribution by consumption category",
  },
  v2_actions_water_tooltip_showers: { fr: "Nombre de douches", en: "Number of showers" },
  v2_actions_water_evolution_water_title: { fr: "Evolution de vos économies d'eau", en: "Your water savings trend" },
  v2_actions_water_evolution_legend: { fr: "Économie en eau", en: "Water savings" },
  v2_graph_prev_month: { fr: "Mois précédent (graphique)", en: "Previous month (chart)" },
  v2_graph_next_month: { fr: "Mois suivant (graphique)", en: "Next month (chart)" },
  v2_rewards_type_code: { fr: "Code de réduction", en: "Discount code" },
  v2_rewards_type_slider: { fr: "Slider", en: "Slider" },
  v2_rewards_type_don_eau: { fr: "Don eau", en: "Water donation" },
  v2_rewards_unnamed: { fr: "Récompense #{id}", en: "Reward #{id}" },
  v2_rewards_sales_last_month: { fr: "le mois dernier", en: "last month" },
  v2_greenmiles_gm_column: { fr: "GreenMiles", en: "GreenMiles" },
  v2_rewards_benefits_upsales: { fr: "Upsales", en: "Upsales" },
  v2_rewards_nav_donations: { fr: "Aller à la page Mes dons", en: "Go to My donations page" },
  v2_rewards_nav_sales: { fr: "Aller à la page Ventes additionnelles", en: "Go to Add-on sales page" },
  v2_rewards_learn_more_aria: { fr: "En savoir plus sur {name}", en: "Learn more about {name}" },
  v2_rewards_modal_details_aria: { fr: "Détails récompense {name}", en: "Reward details {name}" },
  v2_reviews_today: { fr: "aujourd'hui", en: "today" },
  v2_reviews_one_day_ago: { fr: "il y a 1 jour", en: "1 day ago" },
  v2_reviews_days_ago: { fr: "il y a {days} jours", en: "{days} days ago" },
  v2_reviews_stars_tooltip: { fr: "{rating} étoiles : {count} avis", en: "{rating} stars: {count} reviews" },
  v2_reviews_count_label: { fr: "Avis", en: "Reviews" },
  v2_reviews_platform_tooltip: { fr: "{name} : {count} avis", en: "{name}: {count} reviews" },
  v2_reviews_platform_y_axis: { fr: "(Avis)", en: "(Reviews)" },
  v2_reviews_platform_legend: {
    fr: "{name} ({count} avis/{percentage}%)",
    en: "{name} ({count} reviews/{percentage}%)",
  },
  v2_surveys_quiz_question: { fr: "Question du quiz : {question}", en: "Quiz question: {question}" },
  v2_surveys_quiz_default_question: { fr: "Question", en: "Question" },
  v2_surveys_answer_fallback: { fr: "Réponse {position}", en: "Answer {position}" },
  v2_surveys_user_alt: { fr: "utilisateur", en: "user" },
  v2_surveys_legend_aria: { fr: "Légende", en: "Legend" },
  v2_actions_list_nav_aria: { fr: "Aller à la page liée à {name}", en: "Go to page linked to {name}" },
  v2_actions_list_this_action: { fr: "cette action", en: "this action" },
  v2_donation_chart_duration: { fr: "Durée: {label}", en: "Duration: {label}" },
  v2_donation_chart_quantity: { fr: "Quantité: {label}", en: "Quantity: {label}" },
};

export default v2Translations;
